import { Menu } from '@mui/icons-material';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Grid,
  Stack,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { DealerRoutes } from '../../common/Routes';
import { selectUserRoles } from '../../redux/selectors/userDataSelectors';
import AppGlobalSearch from './AppGlobalSearch';
import AppNotificationCenter from './AppNotificationCenter';

const PREFIX = 'AppBarNav';

const classes = {
  menuButton: `${PREFIX}-menuButton`,
  menuIcon: `${PREFIX}-menuIcon`,
  breadCrumb: `${PREFIX}-breadCrumb`,
  appBar: `${PREFIX}-appBar`,
  toolBar: `${PREFIX}-toolBar`,
  breadCrumbTitle: `${PREFIX}-breadCrumb-title`,
};

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  [`& .${classes.menuButton}`]: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      marginRight: '0px',
    },
  },

  [`& .${classes.menuIcon}`]: {
    fill: theme.palette.common.white,
    [theme.breakpoints.only('xl')]: {
      display: 'none',
    },
  },

  [`& .${classes.breadCrumb}`]: {
    flexGrow: 1,
  },

  [`&.${classes.appBar}`]: {
    backgroundColor: theme.palette.grey[900],
    boxShadow: 'none',
    borderLeft: '0.6px solid #E0E0E0',
    borderBottom: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('xl')]: {
      zIndex: 1250,
    },
  },

  [`& .${classes.toolBar}`]: {
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(0),
    },
    [theme.breakpoints.only('lg')]: {
      paddingLeft: theme.spacing(1),
    },
  },

  [`& .${classes.breadCrumbTitle}`]: {
    [theme.breakpoints.only('xl')]: {
      marginLeft: '240px',
    },
  },
}));

const MatchingRoute = route => useRouteMatch(route);

const AppBarNav = props => {
  const userRoles = useSelector(selectUserRoles);
  const routes = DealerRoutes(userRoles);
  const currentRoute = routes.filter(r => MatchingRoute(r.path)?.isExact);

  return (
    <StyledAppBar position="fixed" color="default" className={classes.appBar}>
      <Toolbar className={classes.toolBar}>
        <IconButton
          data-test="app-bar-nav-menu-button"
          data-testid="appBarNavMenuButton"
          aria-label="menu"
          className={classes.menuButton}
          onClick={() => props.handleOpen()}
          size="large"
          sx={{ display: { xl: 'none' } }}
        >
          <Menu className={classes.menuIcon} />
        </IconButton>
        <Grid container direction="row" alignItems="center">
          <Grid item className={classes.breadCrumb}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography
                variant="subtitle1"
                color="white"
                className={classes.breadCrumbTitle}
              >
                {currentRoute[0].name}
              </Typography>
              <Stack direction="row">
                <AppGlobalSearch />
                <AppNotificationCenter />
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Toolbar>
    </StyledAppBar>
  );
};

export default AppBarNav;
